<mat-toolbar>
  <app-toggle-sidebar></app-toggle-sidebar>
  <span class="title"></span>
  <a class="logo">
    <img src="../../../../../assets/img/logo-logimaps.png" height="39" alt="">
    <span class="pl-2">Logi<span class="logo-name">Maps</span></span>
  </a>
</mat-toolbar>
